import {DEFAULT_CONSTANT, IKey} from "../../constant/default";

export class ConstantService {
    static getConstant(key: keyof IKey){
        return DEFAULT_CONSTANT[key]
    }
}
